
  
const initState = {
    invoice: [],
    page: 1,
    limit: 10,
    count: 0,
    invoiceDetail: []
  };
  
  const InvoiceReducer = (state = initState, action) => {
    switch (action.type) {
      case 'SET_INVOICE':
        return {
          ...state,
          invoice: action.payload.data,
          page: action.payload.page,
          limit: action.payload.limit,
          count: action.payload.count
        };
      case 'SET_INVOICE_DETAIL':
        return {
          ...state,
          invoiceDetail: action.payload.data
        };
      case 'RESET_INVOICE_STATE':
        return {
          ...state,
          ...initState
        };
      default:
        return { ...state };
    }
  };
  
  export default InvoiceReducer;
  